import useInputKeys from 'hooks/useInputKeys';
import { useTranslation } from 'react-i18next';
import { setItem } from "lib/Storage";
import "./index.scss";

const Language = () => {
  const { setDirection } = useInputKeys();
  const { i18n } = useTranslation();

  const handleLng = (lng, dir) => {
    setItem('lng', lng);
    setItem('dir', dir);
    i18n.changeLanguage(lng);
    setDirection(dir);
  }
  const lngs = [
    {
      lng: 'en',
      name: 'English',
      dir: 'ltr',
    },
    {
      lng: 'fa',
      name: 'فارسی',
      dir: 'rtl',
    },
  ];

  return (
    <div className="language-component-wrapper">
      {lngs.map(({ lng, name, dir }) => (
        <div
          key={lng}
          className={`box-shadow ${dir} ${i18n.resolvedLanguage === lng ? 'active-language' : ''}`}
          onClick={() => handleLng(lng, dir)}
        >
          {name}
        </div>
      ))}
    </div>
  );
};

export default Language;
